interface BuyerFlowNextDisabledParams {
  isDetailsStep: boolean;
  buyerCount: number;
  isSupplementarySigned: boolean;
}

/** Every step needs at least one buyer; the declaration step also needs the signed supplementary form. */
export function isBuyerFlowNextDisabled({
  isDetailsStep,
  buyerCount,
  isSupplementarySigned
}: BuyerFlowNextDisabledParams): boolean {
  return buyerCount === 0 || (!isDetailsStep && !isSupplementarySigned);
}
